



















































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { AdminApi } from '@/services/AdminApi';
import { IAgency, IUser, UserRoleType } from 'admiral-core';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormatMixin } from '@/mixins/FormatMixin';
import { mixins } from 'vue-class-component';
import { Util } from '@/utils/Util';
import { LinkIcon, PlusIcon } from 'vue-feather-icons';
import AgencyDetail from '@/views/pages/admin/components/AgencyDetail.vue';
import AgenciesActivity from '@/views/pages/admin/components/AgenciesActivity.vue';
import CreateTaskModal from '@/views/pages/tasks/CreateTaskModal.vue';
import CreateAgencyModal from '@/views/pages/admin/CreateAgencyModal.vue';
import EditAgencyModal from '@/views/pages/admin/EditAgencyModal.vue';

@Component({
  name: 'agencies',
  components: {
    EditAgencyModal,
    CreateAgencyModal,
    CreateTaskModal,
    AgenciesActivity,
    AgencyDetail,
    LinkIcon,
    PlusIcon,
  },
})
class Agencies extends mixins(FormatMixin, BaseMixin) {
  agencies: IAgency[] = [];
  agenciesOnline: IAgency[] = [];

  selectedAgency: Partial<IAgency> = {};

  async mounted() {
    await this.loadAgencies();
  }

  async loadAgencies() {
    const response = await AdminApi.getAgencies();
    this.agencies = response.data;

    const responseAgenciesOnline = await AdminApi.getOnlineAgencies();
    this.agenciesOnline = responseAgenciesOnline.data;
  }

  getAgencyAdmin(agency: IAgency) {
    return agency.users.filter((user: IUser) => user.role.type === UserRoleType.ADMIN);
  }

  getDate(date: Date) {
    return Util.formatDate(date);
  }

  async reload() {
    await this.loadAgencies();
  }

  openEditModal(agency: IAgency) {
    this.selectedAgency = agency;
    // eslint-disable-next-line
    (this.$refs['edit-agency-modal'] as any).$refs['edit-agency'].show();
  }
}

export default Agencies;
